.ld-tooltip__trigger {
  /* themable colors */
  --ld-tooltip-trigger-icon-col: var(--ld-thm-primary);
  --ld-tooltip-trigger-icon-col-hover: var(--ld-thm-primary-hover);
  --ld-tooltip-trigger-icon-col-focus: var(--ld-thm-primary-focus);

  background: none;
  border: 0;
  display: inline-block;
  font-family: inherit;
  font-size: inherit;
  padding: 0;
  color: inherit;

  &--clickable {
    cursor: pointer;
  }

  &:focus:focus-visible .ld-tooltip__icon {
    color: var(--ld-tooltip-trigger-icon-col-focus);
  }

  &:hover .ld-tooltip__icon {
    color: var(--ld-tooltip-trigger-icon-col-hover);
  }

  ~ .ld-tooltip {
    opacity: 0;
    position: absolute;
    display: none;
  }
}

.ld-tooltip__icon {
  color: var(--ld-tooltip-trigger-icon-col);
  display: flex;
  height: var(--ld-sp-16);
  width: var(--ld-sp-16);
}

.ld-tooltip__content {
  display: none;
}
